 const CustomLegend = ({legends, filterIds, onClick}) => (
  <div className="flex justify-center gap-5 mb-2.5 text-xs">
    {legends.map(l => {
      const active = filterIds.includes(l.id)

      return (
        <button 
          key={l.id}
          onClick={() => onClick(l.id)}
          className="flex items-center gap-1.25 cursor-pointer"
          style={{ opacity: active ? 1 : 0.3 }}
        >
          <div className={`w-8 h-3 bg-linear-to-r ${l.gradient} rounded-xs`} />
          <span>{l.label}</span>
        </button>
      )
    })}
  </div>
)

export default CustomLegend